import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractValueRowTemplate from "./AbstractValueRowTemplate.js";
import KeyFigureRow from "../../reports/rows/KeyFigureRow.js";

/**
 * Key figure template row.
 *
 * @param {string} [spec.keyFigureId] - Id of the key figure.
 * @param {string} [spec.keyFigureName] - Name of the key figure.
 * @param {string} [spec.style] - Style used to display the row.
 * @param {boolean} [spec.negated=false] - Whether the row's value
 * should be the opposite of the corresponding kpi value.
 */
export default class KeyFigureRowTemplate extends AbstractValueRowTemplate {
	constructor({
		keyFigureId,
		keyFigureName,
		style = "text",
		negated = false,
	} = {}) {
		super(...arguments);

		this._keyFigureId = keyFigureId || "NetSales";
		this._keyFigureName = keyFigureName || _("Net Sales");
		this._style = style;
		this._negated = negated;
	}

	getKeyFigureId() {
		return this._keyFigureId;
	}

	getTitle() {
		return this._keyFigureName;
	}

	getStyle() {
		return this._style;
	}

	setStyle(style) {
		this._style = style;
	}

	isNegated() {
		return this._negated;
	}

	setNegated(value) {
		this._negated = value;
	}

	setKeyFigure(keyFigure) {
		this._keyFigureId = keyFigure.getId();
		this._keyFigureName = keyFigure.getName();
	}

	accept(visitor) {
		return visitor.visitKeyFigureRowTemplate(this);
	}

	_instanceClass() {
		return KeyFigureRow;
	}

	_interpretationSpec(interpreter) {
		const spec = super._interpretationSpec(...arguments);
		const context = interpreter.getContext();

		spec.keyFigure = context.findKeyFigure(this._keyFigureId);
		spec.style = this._style;
		spec.negated = this._negated;

		return spec;
	}

	_serializedProperties() {
		const properties = super._serializedProperties(...arguments);

		properties.keyFigureId = this._keyFigureId;
		properties.keyFigureName = this._keyFigureName.toString();
		properties.style = this._style;
		properties.negated = this._negated;

		return properties;
	}

	static getLabel() {
		return _("Key Figure");
	}

	static getType() {
		return "KeyFigureRowTemplate";
	}
}
